// extracted by mini-css-extract-plugin
export default {"content":"styles_content__kiEMh","contentAnimation":"styles_contentAnimation__XjZjh"};